/**
 * Generic key/value persistence for UI state that should survive a remount
 * (e.g. a context provider keyed by an id) within the same browser session.
 * Callers own their key namespacing; this module only handles the storage
 * read/write/serialize concerns, non-fatally, since storage can throw in
 * private browsing, when disabled, or on a full quota.
 */
const STORAGE_PREFIX = 'v1:persistedState:';

export function readPersistedState<T>(key: string): T | null {
    try {
        const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
        return raw ? (JSON.parse(raw) as T) : null;
    } catch {
        return null;
    }
}

export function writePersistedState<T>(key: string, value: T): void {
    try {
        sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(value));
    } catch {
        // Non-fatal: losing the hint only costs the persisted selection.
    }
}

export function removePersistedState(key: string): void {
    try {
        sessionStorage.removeItem(`${STORAGE_PREFIX}${key}`);
    } catch {
        // Non-fatal.
    }
}
